export const Constants = {
  EXTERNAL_DEBTS_DATE_FACTOR: 30.416,
  NOT_ALLOWED_PATRONS: [
    '151101',
    '201704064',
    '999999',
    '999995',
    '999992',
    '999993',
    '201503683',
    '201603714',
    '201804424',
    '201904484',
    '999994',
    '201002228',
    '201804279',
  ],
  ALLOWED_PATRONS_TC_PED:[
    '206001',
    '316236',
    '246001',
    '704101',
    '276001',
    '236001',
    '326001',
    '226001',
    '266001',
    '26701',
    '26601',
    '736001',
    '216001',
    '46001'
  ],
  PATRONOS_PAGO_VOLUNTARIO: [
    {
      "nombrePatrono": "PAGOS DIRECTOS A CAJA PRIVADAS",
      "numeroPatrono": "999999",
      "fuenteIngreso": "ASALARIADO"
  },{
      "nombrePatrono": "PAGOS DIRECTOS A CAJA PRIVADAS",
      "numeroPatrono": "999999",
      "fuenteIngreso": "SERVICIOS PROFESIONALES"
  }, {
      "nombrePatrono": "PAGOS POR CAJA ENTIDADES DESCENTRALIZADAS",
      "numeroPatrono": "999995",
      "fuenteIngreso": "ASALARIADO"
  }, {
      "nombrePatrono": "PAGOS POR CAJA ENTIDADES DESCENTRALIZADAS",
      "numeroPatrono": "999995",
      "fuenteIngreso": "SERVICIOS PROFESIONALES"
  }, {
      "nombrePatrono": "PAGOS POR CAJA ENTIDADES PREFERENTES",
      "numeroPatrono": "999994",
      "fuenteIngreso": "ASALARIADO"
  },{
      "nombrePatrono": "PAGOS DIRECTOS A CAJA INDEPENDIENTES",
      "numeroPatrono": "201804424",
      "fuenteIngreso": "INDEPENDIENTES"
  }
  ]
};
